<template>
  <div id="web-app">
    <div id="particleJs"></div>
    <b-navbar
      class="bg-filter navbar-stl"
      :fixed-top="true"
      wrapper-class="container"
    >
      <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <img
            src="@/assets/img/cep_logotipo_full_white.png"
            alt="cep_logotipo_full_white"
          />
        </b-navbar-item>
      </template>
      <template slot="end">
        <b-navbar-item class="navbar-item-stl" @click="itemMenu('banner')">
          {{ $t("nav[0]") }}
        </b-navbar-item>
        <b-navbar-item class="navbar-item-stl" @click="itemMenu('about')">
          {{ $t("nav[5]") }}
        </b-navbar-item>
        <b-navbar-item class="navbar-item-stl" @click="itemMenu('highlights')">
          {{ $t("nav[6]") }}
        </b-navbar-item>
        <b-navbar-item class="navbar-item-stl" @click="itemMenu('solutions')">
          {{ $t("nav[1]") }}
        </b-navbar-item>
        <b-navbar-item class="navbar-item-stl" @click="itemMenu('industries')">
          {{ $t("nav[2]") }}
        </b-navbar-item>
        <b-navbar-item class="navbar-item-stl" @click="itemMenu('work')">
          {{ $t("nav[3]") }}
        </b-navbar-item>
        <b-navbar-item class="navbar-item-stl" @click="itemMenu('allies')">
          {{ $t("nav[4]") }}
        </b-navbar-item>

        <b-navbar-item tag="div">
          <BtnDemo />
        </b-navbar-item>

        <b-navbar-dropdown>
          <b-navbar-item slot="label" class="btn-locale">
            <img
              :src="getImgUrl(currentLocale)"
              :alt="currentLocale"
              style="margin-right: 0.5em; width: 15px"
            />
            {{ $t("locale." + currentLocale) }}
          </b-navbar-item>
          <b-navbar-item
            v-for="(lang, index) in availableLocales"
            aria-role="listitem"
            @click="changeLocale(lang)"
            :key="index"
          >
            <img
              class="is-hidden-mobile"
              :src="getImgUrl(lang)"
              :alt="lang"
              style="margin-right: 0.5em; width: 15px"
            />
            {{ $t("locale." + lang) }}
          </b-navbar-item>
        </b-navbar-dropdown>
      </template>
      <!-- <template slot="burger">
        <b-navbar-item
          @click="menumodal"
          class="is-hidden-desktop navbar-burger burger has-text-white"
        >
          <i class="fa fa-bars"></i>
        </b-navbar-item>
      </template> -->
    </b-navbar>
    <router-view />
    <footer class="footer bg-filter">
      <br />
      <br />
      <div class="container">
        <div class="columns">
          <div class="column is-6">
            <p class="has-text-white-ter">
              <img
                src="@/assets/img/flags/chile.png"
                alt="chile"
                class="icon"
                style="
                  width: 1.7rem;
                  height: 1.7rem;
                  margin-right: 0.3rem;
                  vertical-align: top;
                "
              />
              <span>&nbsp;&nbsp;{{ $t("web.dirChile") }}</span>
            </p>
            <br />
            <p class="has-text-white-ter">
              <img
                src="@/assets/img/flags/usa.png"
                alt="usa"
                class="icon"
                style="
                  width: 1.7rem;
                  height: 1.7rem;
                  margin-right: 0.3rem;
                  vertical-align: top;
                "
              />
              <span>&nbsp;&nbsp;{{ $t("web.dirUsa") }}</span>
            </p>
            <br />
            <p>
              <u>
                <a :href="'tel:' + $t('web.tel')" class="has-text-white-ter">
                  <i
                    class="fa-2x fa fa-phone-square-alt"
                    style="margin-right: 0.3rem; vertical-align: top"
                  ></i>
                  <span>&nbsp;&nbsp;{{ $t("web.tel") }}</span>
                </a>
              </u>
            </p>
            <br />
            <p>
              <u>
                <a
                  :href="'mailto:' + $t('web.email')"
                  class="has-text-white-ter"
                >
                  <i
                    class="fa-2x fa fa-at"
                    style="margin-right: 0.3rem; vertical-align: top"
                  ></i>
                  <span>&nbsp;&nbsp;{{ $t("web.email") }}</span>
                </a>
              </u>
            </p>
            <br />
            <p>
              <u>
                <a
                  href="https://www.youtube.com/@CEPTINEL.oficial"
                  class="has-text-white-ter"
                >
                  <img
                    src="@/assets/img/icons/youtube.svg"
                    alt="usa"
                    class="icon"
                    style="
                  width: 1.7rem;
                  height: 1.7rem;
                  margin-right: 0.3rem;
                  vertical-align: top;
                "
                  />
                  <span>&nbsp;&nbsp;Youtube</span>
                </a>
              </u>
            </p>
            <br />
            <p>
              <a
                href="https://www.linkedin.com/company/ceptinel"
                target="_blank"
                class="has-text-white-ter"
              >
                <img
                  src="@/assets/img/icons/linkedin.svg"
                  class="icon"
                  style="
                    width: 1.7rem;
                    height: 1.7rem;
                    margin-right: 0.3rem;
                    vertical-align: top;
                  "
                />
                <span>&nbsp;&nbsp;LinkedIn </span>
              </a>
            </p>
          </div>
          <div class="column is-2"></div>
          <div class="column has-text-right">
            <BtnDemo />
            <br />
            <br />
            <!-- <h3 class="has-text-white-ter is-size-6 has-text-right">
              {{ $t("web.slogan") }}
            </h3> -->
            <p class="has-text-white-ter has-text-right">
              CEPTINEL© . All rights reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import "particles.js";
import particlesConfig from "@/particlesConfig";
import i18n from "@/i18n.js";
import BtnDemo from "./components/BtnDemo";
import menuModal from "./components/menu-modal";
export default {
  name: "APP",
  components: { BtnDemo },
  data() {
    return {
      title: "app",
    };
  },
  mounted() {
    document.title = "Ceptinel";
    window.particlesJS("particleJs", particlesConfig);
  },
  methods: {
    getImgUrl(pic) {
      return require("@/assets/img/flags/" + pic + ".svg");
    },
    changeLocale(setLocale) {
      i18n.locale = setLocale;
      this.$root.$emit("changeLocale", setLocale);
    },
    itemMenu(route) {
      if (this.$route.name == "home") this.$scrollTo("#" + route);
      else this.$router.push({ path: "/#" + route });
    },
    menumodal() {
      this.$buefy.modal.open({
        parent: this,
        component: menuModal,
        trapFocus: true,
      });
    },
  },
  computed: {
    currentLocale() {
      return i18n.locale;
    },
    availableLocales() {
      return i18n.availableLocales;
    },
  },
};
</script>
<i18n>
{
  "es": {
      "locale":{
        "es":"Español",
        "en":"Inglés",
        "pt":"Portugues"
      },
      "nav": ["Inicio ","Módulos","Industrias","Cómo Funciona","Alianzas","Quiénes somos","Destacados"],
      "web": {
        "sloganImg":      "sloganEs.svg",
        "howWorkImg":     "es-howWork.png",
        "slogan":         "DETECTAR - ALERTAR - PREVENIR",
        "dirChile":       "Chile: Andrés de Fuenzalida 22 of 602, Providencia, Santiago",
        "dirUsa":         "EEUU: 848 Brickell Ave #1210 - Miami - FL33131",
        "tel":          "+56 996668379",
        "email":          "info@ceptinel.com",
        "linkedin":       "https://www.linkedin.com/company/ceptinel",
        "copy":           "Alertas automáticas para cumplimiento regulatorio y prevención de fraude",
        "tag":            "Implementación Simple y Rápida"
      }
  },
  "en": {
      "locale":{
        "es":"Spanish ",
        "en":"English",
        "pt":"Portuguese"
      },
      "nav": ["Home", "Modules", "Industries", "How it works", "Alliances", "About us", "Highlights"],
      "web": {
        "sloganImg":      "/static/img/sloganEn.svg",
        "howWorkImg":     "/static/img/en-howWork.png",
        "slogan":         "DETECT - ALERT - PREVENT",
        "email":          "info@ceptinel.com",
        "dirChile":       "Chile: Andrés de Fuenzalida 22 of 602, Providencia, Santiago",
        "dirUsa":         "USA: 848 Brickell Ave #1210 - Miami - FL33131",
        "tel":            "+56 996668379",
        "linkedin":       "https://www.linkedin.com/company/ceptinel",
        "copy":           "Process and combine millions of data from multiple sources in real time",
        "tag":            "Simple and Fast Implementation"
      }
  },
  "pt": {
      "locale":{
        "es":"Espanhol",
        "en":"Inglês",
        "pt":"Português"
      },
      "nav": ["Inicio", "Módulos", "Indústrias", "Como funciona", "Alianças", "Quem somos", "Destaque"],
      "web": {
        "sloganImg":      "/static/img/sloganPt.svg",
        "howWorkImg":     "/static/img/pt-howWork.png",
        "email":          "info@ceptinel.com",
        "slogan":         "DETECTAR - ALERTAR - EVITAR",
        "dirChile":       "Chile: Andrés de Fuenzalida 22 of 602, Providencia, Santiago",
        "dirUsa":         "USA: 848 Brickell Ave #1210 - Miami - FL33131",
        "tel":            "+56 996668379",
        "linkedin":       "https://www.linkedin.com/company/ceptinel",
        "copy":           "Processe e combine milhões de dados de várias fontes em tempo real",
        "tag":           "Implementação Simples e Rápida"
      }
  }
}
</i18n>
<style scoped>
.navbar-stl .navbar-item-stl {
  color: #ffffff;
}
.navbar-item.has-dropdown.is-active .btn-locale {
  color: #5a2c7e !important;
}
.navbar-stl .navbar-item-stl:hover {
  color: #5a2c7e;
}
.btn-locale {
  color: #ffffff;
}
.btn-locale:hover {
  color: #5a2c7e;
}
#particleJs {
  position: fixed;
  width: 100%;
  height: 100vh;
}

.navbar-menu.is-active .navbar-item-stl,
.navbar-menu.is-active .btn-locale {
  color: #000000;
}
</style>
